<template>
	<div class="" style="width: 165px;margin: 25% auto;padding: 20px;text-align: center;">
			<van-image
			  width="100px"
			  height="75px"
			  :src="noDataImg"
			/>
			<div class="cardTitleSub textCenter paddingTopBottomXs">{{title}}</div>
	</div>
</template>

<script>
	export default {
		props:["noneType"],
		data() {
			return {
				title:'',
				noDataImg:this.$mAssetsPath.noDataImg,
			};
		},
		created() {
			if(this.noneType==2){
				this.title="网络不佳";
			}else if(this.noneType==3){
				this.title="已被删除";
			}else if(this.noneType==1){
				this.title="暂无活动";
			}else{
				this.title="暂无信息";
			}
			
		}
	}
</script>

<style>

</style>
